export default "__VITE_ASSET__a264b407__"